import {
  fetchHireCard,
  fetchHireTableAndChart,
  fetchHireDepartmentVisual,
  fetchHireSourceVisual,
  fetchHireDrilldown,
} from './actions';
import { getDefaultAtsFilters, buildReportsSlice } from '../common/ats-filters';
import { flatTransformer, getTableData } from '../common/flat-transformer';
import { cardTransformer } from '../common/card-transformer';
import { visualPayload } from '../common/visual-transformer';
import { getPercentage } from '../common/get-percentage';

const getChartData = (response) => {
  const {
    chart = [],
    headers,
    lookups: { dt, g1, g2 } = {},
  } = response?.data || {};
  return flatTransformer({ headers, datas: chart, g1, g2, dt });
};

const tableWithTotal = (data) => {
  const hires_total = data?.reduce((acc, curr) => acc + curr?.hires, 0);

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      return {
        ...datum,

        hires_total,
        hires_per: getPercentage(datum?.hires, hires_total),
        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};

const constructDrilldownData = (payload) => {
  const k1Map = payload?.data?.lookups?.k1;
  const k2Map = payload?.data?.lookups?.k2;
  const k3Map = payload?.data?.lookups?.k3;
  const k4Map = payload?.data?.lookups?.k4;
  const k5Map = payload?.data?.lookups?.k5;
  const k6Map = payload?.data?.lookups?.k6;
  const k7Map = payload?.data?.lookups?.k7;
  const k8Map = payload?.data?.lookups?.k8;
  const returnData = payload?.data?.table?.map((data) => {
    const [, k1, k2, k3, k4, k5, k6, k7, k8, time_to_hire] = data;
    return {
      ...k1Map?.[k1],
      source: k2Map?.[k2],
      credited_to: k3Map?.[k3],
      hire_requisition_code: k4Map?.[k4],
      hired_by: k5Map?.[k5],
      job: k6Map?.[k6],
      department: k7Map?.[k7],
      office_names: k8Map?.[k8],
      time_to_hire,
    };
  });
  return returnData;
};

const initialState = {
  ...getDefaultAtsFilters(),

  isCardLoading: false,
  cards: {},

  hiresByDepartment: [],
  isHiresByDepartmentLoading: false,

  hiresBySource: [],
  isHiresBySourceLoading: false,

  chart: [],
  table: [],
  isChartLoading: false,
  isTableLoading: false,
  isDrillLoading: false,
  initialLoading: false,
  drilldownData: [],
  stageMapping: {},
  totalCount: 0,
  currentDrillPage: 1,
};

const extraReducers = {
  [fetchHireCard.pending]: (state) => {
    state.isCardLoading = true;
  },
  [fetchHireCard.fulfilled]: (state, { payload }) => {
    state.cards = cardTransformer(payload);
    state.isCardLoading = false;
  },
  [fetchHireCard.rejected]: (state) => {
    state.isCardLoading = false;
  },

  [fetchHireDepartmentVisual.pending]: (state) => {
    state.isHiresByDepartmentLoading = true;
  },
  [fetchHireDepartmentVisual.fulfilled]: (state, { payload }) => {
    state.hiresByDepartment = visualPayload(payload);
    state.isHiresByDepartmentLoading = false;
  },
  [fetchHireDepartmentVisual.rejected]: (state) => {
    state.isHiresByDepartmentLoading = false;
  },

  [fetchHireSourceVisual.pending]: (state) => {
    state.isHiresBySourceLoading = true;
  },
  [fetchHireSourceVisual.fulfilled]: (state, { payload }) => {
    state.hiresBySource = visualPayload(payload);
    state.isHiresBySourceLoading = false;
  },
  [fetchHireSourceVisual.rejected]: (state) => {
    state.isHiresBySourceLoading = false;
  },

  [fetchHireTableAndChart.pending]: (state) => {
    state.isChartLoading = true;
    state.isTableLoading = true;
  },

  [fetchHireTableAndChart.fulfilled]: (state, { meta, payload = {} }) => {
    state.isChartLoading = false;
    state.isTableLoading = false;
    state.chart = getChartData(payload);
    state.table = tableWithTotal(getTableData(payload, meta?.arg));
  },

  [fetchHireTableAndChart.rejected]: (state) => {
    state.isChartLoading = false;
    state.isTableLoading = false;
  },
  [fetchHireDrilldown.pending]: (state, { meta }) => {
    const { drilldown } = meta?.arg || {};
    if (drilldown.page === 1) {
      state.initialLoading = true;
    } else {
      state.isDrillLoading = true;
    }
  },
  [fetchHireDrilldown.fulfilled]: (state, { meta, payload = {} }) => {
    if (!payload) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;

    const { drilldown } = meta?.arg || {};
    const newData = constructDrilldownData(payload);

    state.totalCount = payload?.data?.pagination?.total_count;

    if (drilldown.page === 1) {
      state.drilldownData = newData;
    } else {
      state.drilldownData = [...state.drilldownData, ...newData];
    }
    state.currentDrillPage = drilldown.page;
  },
  [fetchHireDrilldown.rejected]: (state, action) => {
    if (
      action.error?.name === 'AbortError' ||
      action.error?.name === 'CanceledError'
    ) {
      return;
    }
    state.isDrillLoading = false;
    state.initialLoading = false;
  },
};

export const { reducer, actions } = buildReportsSlice({
  name: 'atsHireReport',
  initialState,
  extraReducers,
});

export const {
  applyFilter,
  resetFilter,
  applyTimeFrame,
  applyViewBy,
  applyGroup,
  setFiltersData,
  applySearch,
  resetDrillDown,
} = actions;
export default reducer;
